<template>
  <b-container fluid>
    <linkCard
      v-for="(links, key) in linkCardData"
      :key="key"
      :id="key"
      :title="links.title"
      :thumbnail="require('../assets/200/' + links.thumbnailLink)"
      :description="links.dsc"
      :link="links.link"
      :maintnance="links.maintnance"
      :update="links.update"
      :prototype="links.prototype"
    />
  </b-container>
</template>

<script>
import linkCard from "./linkCard.vue";

export default {
  name: "link-card-container",
  components: {
    linkCard,
  },
  props: {
    linkCardData: Array,
    title: String,
    color: String,
  },
};
</script>
